export const STAGE_ORDER_FULL = ['aptitude', 'sjt', 'video', 'practical', 'ceo_call', 'physical_meeting'];
export const STAGE_ORDER_NON_CRAFT = STAGE_ORDER_FULL.filter((s) => s !== 'practical');

export const STAGE_LABELS = {
  aptitude: 'Aptitude Test',
  sjt: 'Scenario Judgment Test',
  video: 'Video Answers',
  practical: 'Practical Work-Sample',
  ceo_call: 'CEO Video Call',
  physical_meeting: 'Physical Meeting',
};

export const HUMAN_REVIEW_STAGES = ['video', 'practical', 'ceo_call', 'physical_meeting'];
export const AUTO_STAGES = ['aptitude', 'sjt'];

export const STATUS_BADGE = {
  in_progress: 'bg-blue-100 text-blue-700',
  rejected: 'bg-red-100 text-red-700',
  offered: 'bg-green-100 text-green-700',
  hired: 'bg-emerald-100 text-emerald-700',
};

export const stageOrderFor = (isCraft) => (isCraft ? STAGE_ORDER_FULL : STAGE_ORDER_NON_CRAFT);
